import { useGetVehicleInteractionQuery } from '@customer/store/apis/interactionsApi';
import { useAppSelector } from '@customer/store/hooks';
import { skipToken } from '@reduxjs/toolkit/query';
import { useParams } from 'react-router-dom';

// The purpose of this hook is to make it easier to keep the query identical between parent and child components for the sake of caching.
export const useVehicleInteraction = () => {
  const globalState = useAppSelector(state => state.global);
  const { assetId } = useParams();

  const { currentData: interaction, error } = useGetVehicleInteractionQuery(
    globalState.sidePanelModelId && assetId
      ? { assetId, interactionId: globalState.sidePanelModelId }
      : skipToken,
    { refetchOnMountOrArgChange: 10 },
  );

  return {
    interaction,
    error,
  };
};

export default useVehicleInteraction;
